<template>
    <div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control company_name" id="company_name" :placeholder="$t('company.firemneudaje_text_1')"
                        v-model="user.fa_company">
                <label for="company_name">{{ $t('company.firemneudaje_text_1') }}</label>
            </div>
        </div>
        <div class="two mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control company_ico" id="company_ico" :placeholder="$t('company.firemneudaje_text_2')"
                        @keypress="ico_checker" v-model="user.fa_ico">
                <label for="company_ico">{{ $t('company.firemneudaje_text_2') }}</label>
            </div>
            <div class="form-floating">
                <input  type="text" class="form-control company_dic" id="company_dic" :placeholder="$t('company.firemneudaje_text_3')"
                        @keypress="dic_checker" v-model="user.fa_dic">
                <label for="company_dic">{{ $t('company.firemneudaje_text_3') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control company_icdph" id="company_icdph" :placeholder="$t('company.firemneudaje_text_4')"
                        v-model="user.fa_icdph">
                <label for="company_icdph">{{ $t('company.firemneudaje_text_4') }}</label>
            </div>
        </div>
        <div class="one mt-3">
            <div class="form-floating">
                <input  type="text" class="form-control company_adress" id="company_adress" :placeholder="$t('company.firemneudaje_text_5')"
                        v-model="user.fa_address">
                <label for="company_adress">{{ $t('company.firemneudaje_text_5') }}</label>
            </div>
        </div>
        <div class="three mt-3">
            <div class="form-floating left">
                <input  type="text" class="form-control company_psc" id="company_psc" :placeholder="$t('company.firemneudaje_text_6')"
                        @keypress="psc_checker" v-model="user.fa_psc">
                <label for="company_psc">{{ $t('company.firemneudaje_text_6') }}</label>
            </div>
            <div class="form-floating right">
                <input  type="text" class="form-control company_town" id="company_town" :placeholder="$t('company.firemneudaje_text_7')"
                        v-model="user.fa_town">
                <label for="company_town">{{ $t('company.firemneudaje_text_7') }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            user: null,
        }
    },
    created () {
        this.user = this.data
    },
    methods: {
        sendData() {
            this.$emit('data', this.user)
        },
        psc_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 4) {
                this.user.fa_psc = cleanedVal.substr(0, 4); // Limit length to 8 characters
            } else {
                this.user.fa_psc = cleanedVal;
            }
        },
        ico_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 7) {
                this.user.fa_ico = cleanedVal.substr(0, 7); // Limit length to 8 characters
            } else {
                this.user.fa_ico = cleanedVal;
            }
        },
        dic_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 9) {
                this.user.fa_dic = cleanedVal.substr(0, 9); // Limit length to 8 characters
            } else {
                this.user.fa_dic = cleanedVal;
            }
        },
    },
    watch: {
        user: function(){
            this.sendData()
        },
    },
}
</script>

<style lang="scss" scoped>
.three{
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media only screen and (max-width: 600px) {
        display: block;
    }
    .form-floating.left{
        width: 167px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }
    .form-floating.right{
        width: 246px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }
}
.two{
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media only screen and (max-width: 600px) {
        display: block;
    }
    .form-floating{
        width: 210px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }
}
.form-floating{
    width: 430px;
    height: 55px;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    position: relative;
    input{
        display: flex !important;
        align-items: center !important;
        background: #FFFFFF;
        border: 1px solid #DDE3E8;
        box-sizing: border-box;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        color: #212541;
        padding-left: 23px;
    }
    label{
        display: flex !important;
        align-items: center !important;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598A7;
        padding-left: 23px;
    }
}
</style>